(function () {
  function initWaveAnimations(root) {
    if (typeof gsap === 'undefined') return;

    const scope = root || document;
    const waves = scope.querySelectorAll('.dynamic-wave');

    waves.forEach((wave) => {
      if (wave.dataset.waveInit === 'true') return;
      wave.dataset.waveInit = 'true';

      const path = wave.querySelector('.dynamic-wave__path');
      if (!path) return;

      const duration = Number(wave.dataset.waveDuration) || 12;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      gsap.set(path, { x: 0 });
      gsap.to(path, {
        x: -1920,
        duration,
        ease: 'none',
        repeat: -1,
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initWaveAnimations();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.classList.contains('dynamic-wave')) {
            initWaveAnimations(node.parentElement || document);
          } else {
            initWaveAnimations(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener('shopify:section:load', (event) => {
    initWaveAnimations(event.target);
  });
})();
